@if (tabs.length > 0) {
  <p-tabs #view [value]="startKey" scrollable (valueChange)="lclChange($event)" class="h-full w-full">
    <p-tablist class="!grid overflow-x-auto">
      @for (tab of tabs; track tab.key) {
        <p-tab value="{{ tab.key }}" [disabled]="tab.disabled" (contextmenu)="onTabRightClick($event, tab)">
          @if (tab.headerTemplate) {
            <ng-container *ngTemplateOutlet="tab.headerTemplate"></ng-container>
          } @else {
            <div class="truncate text-nowrap flex flex-row">
              @if (tab.leftIcon) {
                <i class="material-icons text-base">{{ tab.leftIcon }}</i>
              }
              {{ tab.header ?? tab.key }}
            </div>
          }
        </p-tab>
      }
    </p-tablist>
    <p-tabpanels [class.!p-0]="noInset" class="h-full overflow-y-auto">
      @for (tab of tabs; track tab.key) {
        <p-tabpanel value="{{ tab.key }}" class="h-full w-full">
          @if (tab.lazyTemplate) {
            @if (tab.lazyTemplate && (tab.key === currentTab || tab.lazyAndRendered)) {
              <ng-container *ngTemplateOutlet="tab.lazyTemplate"></ng-container>
            } @else {
              Loading...
            }
          } @else {
            <ng-container *ngTemplateOutlet="tab.contentTemplate"></ng-container>
          }
        </p-tabpanel>
      }
    </p-tabpanels>
  </p-tabs>
  <p-contextmenu #contextMenu [model]="rightClickMenu" appendTo="body" />
}
